/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { FTOContract, FTOContractInterface } from "../FTOContract";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "string",
        name: "tokenURI",
        type: "string",
      },
    ],
    name: "TokenMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_tokenURI",
        type: "string",
      },
    ],
    name: "createToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "tokenURIToTokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class FTOContract__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _name: string,
    _symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FTOContract> {
    return super.deploy(
      _name,
      _symbol,
      overrides || {}
    ) as Promise<FTOContract>;
  }
  getDeployTransaction(
    _name: string,
    _symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_name, _symbol, overrides || {});
  }
  attach(address: string): FTOContract {
    return super.attach(address) as FTOContract;
  }
  connect(signer: Signer): FTOContract__factory {
    return super.connect(signer) as FTOContract__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FTOContractInterface {
    return new utils.Interface(_abi) as FTOContractInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FTOContract {
    return new Contract(address, _abi, signerOrProvider) as FTOContract;
  }
}
